<div [class]="chartClass">
    <ng-content></ng-content>
</div>